import React from "react";
import LegalLayout from "@/components/legal/LegalLayout";

export default function CookiePolicy() {
  return (
    <LegalLayout title="Cookie Policy" lastUpdated="1 March 2026" version="1.0">
      <p>
        This Cookie Policy explains how <strong>Connexis Group Ltd</strong> uses cookies and similar technologies on
        connex.is and the Connexis platform. It supplements our <a href="/legal/privacy">Privacy Policy</a>.
      </p>

      <h2>1. What cookies are</h2>
      <p>
        Cookies are small text files stored on your device when you visit a website. They allow the site to remember
        your actions and preferences (such as login state) for a period of time. We also use comparable technologies
        such as <code>localStorage</code> and <code>sessionStorage</code> for similar purposes.
      </p>

      <h2>2. Categories of cookies we use</h2>

      <h3>2.1 Strictly necessary (always on)</h3>
      <p>Essential for the site to function and cannot be switched off. These do not store any personally identifiable information.</p>
      <ul>
        <li><code>connexis_token</code> — your authenticated session token (12-hour expiry).</li>
        <li><code>connexis_cookie_consent</code> — your cookie preferences.</li>
        <li><code>connexis_onboarding_seen_*</code> — first-run tour state.</li>
      </ul>

      <h3>2.2 Analytics (opt-in)</h3>
      <p>Help us understand how visitors interact with the site so we can improve it. Anonymised at the IP level.</p>
      <ul>
        <li>PostHog (self-hosted) — aggregate page views, session duration, conversion funnels.</li>
      </ul>

      <h3>2.3 Marketing (opt-in)</h3>
      <p>Currently not in use. If we add marketing cookies in the future, we will update this policy and obtain fresh consent.</p>

      <h2>3. Managing your preferences</h2>
      <p>
        On your first visit you are presented with a cookie consent banner where you can accept or reject each
        category. You can change your preferences at any time by clicking <strong>"Cookie Preferences"</strong> in
        our footer, or by clearing your browser's cookies.
      </p>

      <h2>4. Your browser controls</h2>
      <p>
        Most browsers let you block or delete cookies via their settings. Note that blocking strictly necessary
        cookies will prevent you from signing in or using the platform.
      </p>

      <h2>5. Contact</h2>
      <p>
        Questions about this Cookie Policy: <a href="mailto:legal@connex.is">legal@connex.is</a>
      </p>
    </LegalLayout>
  );
}
